import React, { useEffect, useState } from "react";
import FrontLayout from "../../../components/layout-new-theme/FrontLayout";
import { useLocation, Link, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { getPageContents } from "../../../actions/admin/cmspage";
import { useLoading } from "../../../components/LoadingContext";
import { ArrowRightIcon } from "../../../components/icons";

const NaritaAirportTransfer = () => {
  const page_name = "cms-narita-airport-transfer";
  const dispatch = useDispatch();
  const history = useHistory();
  const cmspage_state = useSelector((state) => state.cmspage);
  const { cmspage, loading } = cmspage_state;
  const { t, i18n } = useTranslation();
  const lang = i18n.language?.toUpperCase();
  const location = useLocation();
  const [tValue, setTValue] = useState(1);
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tParam = params.get('t');
    if (tParam) {
      if (tParam == 1 || tParam == 2 || tParam == 3) {
        setTValue(tParam);
      } else {
        setTValue(1);
      }
    }
  }, []);

  useEffect(() => {
    dispatch(getPageContents(page_name));
  }, [dispatch]);

  const { showLoading, closeLoading } = useLoading();
  return (
    <FrontLayout>
      {loading ? showLoading(true) : closeLoading(true)}
      <div
        className="hero-image-narita-airport-transfer tw:flex tw:items-end"
        style={{
          background:
            "url('" +
            (lang === "EN"
              ? cmspage?.page_content_en.image3
              : cmspage?.page_content_jp.image3) +
            "')",
        }}
      >
        <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:px-[calc(var(--gx)/2)] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:md:w-[91.6667%] tw:md:flex-none tw:lg:w-3/4 tw:lg:flex-none custom-pt-8 tw:mb-4 tw:lg:pb-12">
          <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:flex tw:flex-col tw:justify-end">
            <p
              className="tw:bg-transparent tw:border-0 tw:py-2 tw:px-4 tw:mb-0 tw:[font-family:var(--font-sans-primary)] tw:font-bold tw:tracking-[3px] tw:text-[0.5rem]! tw:uppercase tw:pl-0 text-gold"
              dangerouslySetInnerHTML={{
                __html:
                  lang === "EN"
                    ? cmspage?.page_content_en.content1
                    : cmspage?.page_content_jp.content1,
              }}
            >
              {/* {t("Airport.Transfer")} */}
            </p>
            <h1
              className="tw:font-bold! tw:mb-6 tw:mt-2"
              dangerouslySetInnerHTML={{
                __html:
                  lang === "EN"
                    ? cmspage?.page_content_en.content2
                    : cmspage?.page_content_jp.content2,
              }}
            >
              {/* {t("Narita.Airport.Transfer")} */}
            </h1>
            <p
              className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:md:w-[58.3333%] tw:md:flex-none text-gold intro tw:mb-12 tw:lg:mb-0"
              dangerouslySetInnerHTML={{
                __html:
                  lang === "EN"
                    ? cmspage?.page_content_en.content3
                    : cmspage?.page_content_jp.content3,
              }}
            >
              {/* {t("Narita.Airport.Transfer.Intro")} */}
            </p>
          </div>
        </div>
      </div>
      {/* <!-- to home btn nav --> */}
      <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:px-[calc(var(--gx)/2)] tw:pt-6 border-bottom-gold">
        <div className="tw:md:mx-4">
          <ul className="tw:px-[calc(var(--gx)/2)] tw:md:w-[91.6667%] tw:md:flex-none tw:lg:w-3/4 tw:lg:flex-none tw:mx-auto tw:flex tw:flex-wrap tw:pl-0 tw:mb-0 tw:list-none tw:border-0 tw:flex-col tw:md:flex-row">
            <li className="tw:mt-auto">
              <button
                onClick={() => history.push("./")}
                className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none btn-add tw:text-[#212529]! tw:pl-0 tw:mb-4"
                type="button"
              >
                <div className="">
                  <i className="bi bi-chevron-left tw:pr-2"></i>
                  <span
                    dangerouslySetInnerHTML={{
                      __html:
                        lang === "EN"
                          ? cmspage?.page_content_en.content4
                          : cmspage?.page_content_jp.content4,
                    }}
                  ></span>
                  {/* {t("Back.To.Home")} */}
                </div>
              </button>
            </li>
          </ul>
        </div>
      </div>
      {/* <!-- to home btn nav --> */}
      {/* <!-- section 1 --> */}
      <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:px-[calc(var(--gx)/2)] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:md:w-[91.6667%] tw:md:flex-none tw:lg:w-3/4 tw:lg:flex-none tw:my-12 tw:lg:pt-12 tw:pb-4">
        <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-0">
          <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:lg:w-[83.3333%] tw:lg:flex-none tw:lg:ml-[8.3333%]">
            <p
              className="tw:text-[#212529]!"
              dangerouslySetInnerHTML={{
                __html:
                  lang === "EN"
                    ? cmspage?.page_content_en.content5
                    : cmspage?.page_content_jp.content5,
              }}
            >
              {/* {t("Narita.Airport.Transfer.Heading.One.Content")} */}
            </p>
          </div>
        </div>
      </div>
      {/* <!-- section 1 end --> */}
      {/* <!-- section 2 where to meet chauffeur --> */}
      <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-0 tw:mb-12 tw:items-center">
        <div className="tw:flex-1 tw:basis-0 tw:grow tw:px-0">
          <hr />
        </div>
        <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:text-center">
          <h3
            dangerouslySetInnerHTML={{
              __html:
                lang === "EN"
                  ? cmspage?.page_content_en.content6
                  : cmspage?.page_content_jp.content6,
            }}
          >
            {/* {t("NaritaAirportMaps.Main.Heading")} */}
          </h3>
        </div>
        <div className="tw:flex-1 tw:basis-0 tw:grow tw:px-0">
          <hr />
        </div>
      </div>
      {/* <!-- section 2 where to meet chauffeur, end --> */}
      {/* <!-- section 2 text --> */}
      <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:px-[calc(var(--gx)/2)] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:md:w-[91.6667%] tw:md:flex-none tw:lg:w-3/4 tw:lg:flex-none tw:my-4 tw:lg:my-12">
        <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-0">
          <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:lg:w-[83.3333%] tw:lg:flex-none tw:lg:ml-[8.3333%]">
            <p
              className="tw:text-[#212529]!"
              dangerouslySetInnerHTML={{
                __html:
                  lang === "EN"
                    ? cmspage?.page_content_en.content7
                    : cmspage?.page_content_jp.content7,
              }}
            >
              {/* {t("NaritaAirportMaps.Intro")} */}
            </p>
          </div>
        </div>
      </div>
      {/* <!-- section 2 text end --> */}
      {/* <!-- section 3 tabs mob --> */}
      <div className="tw:block tw:md:hidden tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:px-[calc(var(--gx)/2)] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:md:w-[91.6667%] tw:md:flex-none tw:lg:w-3/4 tw:lg:flex-none tw:mt-4 tw:lg:my-12">
        <div className="tw:flex tw:flex-wrap tw:mx-0 tw:mb-12 tw:gap-y-6 tw:[--gx:0rem]">
          <ul
            className="tw:px-[calc(var(--gx)/2)] tw:md:w-[91.6667%] tw:md:flex-none tw:lg:w-3/4 tw:lg:flex-none tw:mx-auto tw:flex tw:flex-wrap tw:pl-0 tw:mb-0 tw:list-none tw:text-center tw:border-0 tw:flex-row horizontal-scrollable"
            id="myTab"
            role="tablist"
          >
            <li className="tw:mt-auto" role="presentation">
              <button
                className={`tw:block tw:px-4 tw:py-2 tw:no-underline nav-link-light-bg-alt tw:pb-6 tw:lg:mr-6 ${tValue == 1 && 'active'}`}
                onClick={() => setTValue(1)}
                id="naritaTerminalOne-tab"
                type="button"
                role="tab"
                aria-controls="naritaTerminalOne-tab-pane"
                aria-selected="true"
              >
                {t("Haneda.T1")}
              </button>
            </li>
            <li className="tw:mt-auto" role="presentation">
              <button
                className={`tw:block tw:px-4 tw:py-2 tw:no-underline nav-link-light-bg-alt tw:pb-6 tw:lg:mr-6 ${tValue == 2 && 'active'}`}
                onClick={() => setTValue(2)}
                id="naritaTerminalTwo-tab"
                type="button"
                role="tab"
                aria-controls="naritaTerminalTwo-tab-pane"
                aria-selected="false"
              >
                {t("Haneda.T2")}
              </button>
            </li>
          </ul>
          <div className="" id="myTabContent">
            <div
              className={tValue == 1 ? "tw:block" : "tw:hidden"}
              id="naritaTerminalOne-tab-pane"
              role="tabpanel"
              aria-labelledby="naritaTerminalOne-tab"
              tabIndex="0"
            >
              <div className="tw:flex tw:flex-wrap tw:mx-[calc(var(--gx)/-2)] tw:[--gx:0rem]">
                <div className="tw:mb-4">
                  <div className="tw:flex tw:flex-wrap tw:mx-[calc(var(--gx)/-2)] tw:[--gx:0rem]">
                    <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:md:p-12">
                      <img
                        // src={naritat1}
                        src={
                          lang === "EN"
                            ? cmspage?.page_content_en.image1
                            : cmspage?.page_content_jp.image1
                        }
                        className="img-cover tw:rounded-l-[0.375rem]"
                        alt="Haneda Airport Terminal 1 map"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className={tValue == 2 ? "tw:block" : "tw:hidden"}
              id="naritaTerminalTwo-tab-pane"
              role="tabpanel"
              aria-labelledby="naritaTerminalTwo-tab"
              tabIndex="0"
            >
              <div className="tw:flex tw:flex-wrap tw:mx-[calc(var(--gx)/-2)] tw:[--gx:0rem]">
                <div className="tw:mb-4">
                  <div className="tw:flex tw:flex-wrap tw:mx-[calc(var(--gx)/-2)] tw:[--gx:0rem]">
                    <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:md:p-12">
                      <img
                        // src={naritat2}
                        src={
                          lang === "EN"
                            ? cmspage?.page_content_en.image2
                            : cmspage?.page_content_jp.image2
                        }
                        className="img-cover tw:rounded-l-[0.375rem]"
                        alt="Haneda Airport Terminal 2 map"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- section 1 mob end --> */}
      {/* <!-- section 3 tabs --> */}
      <div className="tw:hidden tw:md:block tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:px-[calc(var(--gx)/2)] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:md:w-[91.6667%] tw:md:flex-none tw:lg:w-3/4 tw:lg:flex-none tw:my-12 tw:pt-12">
        <div className="tw:flex tw:flex-wrap tw:mx-0 tw:mb-12 tw:gap-y-6 tw:[--gx:0rem]">
          <div className="tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem]">
            <ul
              className="tw:flex tw:flex-wrap tw:pl-0 tw:mb-0 tw:list-none tw:border-b tw:border-b-[#dee2e6]"
              id="myTabMd"
              role="tablist"
            >
              <li className="tw:flex-1 tw:basis-0 tw:grow tw:text-center" role="presentation">
                <button
                  onClick={() => { setTValue(1); history.push("/narita-airport-transfer?t=1"); }}
                  className={`tw:h-full tab-link-light-bg-alt tw:py-6 tab-link-light-bg-radius-left tw:border-r-0 ${tValue == 1 && 'active'}`}
                  id="naritaTerminalOne-tab-md"
                  type="button"
                  role="tab"
                  aria-controls="naritaTerminalOne-tab-pane-md"
                  aria-selected="true"
                  dangerouslySetInnerHTML={{
                    __html:
                      lang === "EN"
                        ? cmspage?.page_content_en.content8
                        : cmspage?.page_content_jp.content8,
                  }}
                >
                  {/* {t("Narita.T1")} */}
                </button>
              </li>
              <li className="tw:flex-1 tw:basis-0 tw:grow tw:text-center" role="presentation">
                <button
                  onClick={() => { setTValue(2); history.push("/narita-airport-transfer?t=2"); }}
                  className={`tw:h-full tab-link-light-bg-alt tw:py-6 tab-link-light-bg-radius-right tw:border-l tw:border-l-[#dee2e6] ${tValue == 2 && 'active'}`}
                  id="naritaTerminalTwo-tab-md"
                  type="button"
                  role="tab"
                  aria-controls="naritaTerminalTwo-tab-pane-md"
                  aria-selected="false"
                  dangerouslySetInnerHTML={{
                    __html:
                      lang === "EN"
                        ? cmspage?.page_content_en.content10
                        : cmspage?.page_content_jp.content10,
                  }}
                >
                  {/* {t("Narita.T2")} */}
                </button>
              </li>
              <li className="tw:flex-1 tw:basis-0 tw:grow tw:text-center" role="presentation">
                <button
                  onClick={() => { setTValue(3); history.push("/narita-airport-transfer?t=3"); }}
                  className={`tw:h-full tab-link-light-bg-alt tw:py-6 tab-link-light-bg-radius-right tw:border-l tw:border-l-[#dee2e6] ${tValue == 3 && 'active'}`}
                  id="naritaTerminalThree-tab-md"
                  type="button"
                  role="tab"
                  aria-controls="naritaTerminalThree-tab-pane-md"
                  aria-selected="false"
                  dangerouslySetInnerHTML={{
                    __html:
                      lang === "EN"
                        ? cmspage?.page_content_en.content17
                        : cmspage?.page_content_jp.content17,
                  }}
                >
                  {/* {t("Narita.T2")} */}
                </button>
              </li>
            </ul>
            <div className="" id="myTabContentMd">
              <div
                className={tValue == 1 ? "tw:block" : "tw:hidden"}
                id="naritaTerminalOne-tab-pane-md"
                role="tabpanel"
                aria-labelledby="naritaTerminalOne-tab-md"
                tabIndex="0"
              >
                <div className="tw:flex tw:flex-wrap tw:mx-[calc(var(--gx)/-2)] tw:[--gx:0rem]">
                  <div className="tw:mb-4">
                    <div className="tw:flex tw:flex-wrap tw:mx-[calc(var(--gx)/-2)] tw:[--gx:0rem]">
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:p-12">
                        <img
                          // src={naritat1}
                          src={
                            lang === "EN"
                              ? cmspage?.page_content_en.image1
                              : cmspage?.page_content_jp.image1
                          }
                          className="img-cover tw:rounded-l-[0.375rem]"
                          alt="Narita Airport Terminal 1 map"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={tValue == 2 ? "tw:block" : "tw:hidden"}
                id="naritaTerminalTwo-tab-pane-md"
                role="tabpanel"
                aria-labelledby="naritaTerminalTwo-tab-md"
                tabIndex="0"
              >
                <div className="tw:flex tw:flex-wrap tw:mx-[calc(var(--gx)/-2)] tw:[--gx:0rem]">
                  <div className="tw:mb-4">
                    <div className="tw:flex tw:flex-wrap tw:mx-[calc(var(--gx)/-2)] tw:[--gx:0rem]">
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none">
                        <img
                          // src={naritat2}
                          src={
                            lang === "EN"
                              ? cmspage?.page_content_en.image2
                              : cmspage?.page_content_jp.image2
                          }
                          className="img-cover tw:rounded-l-[0.375rem]"
                          alt="Narita Airport Terminal 2 map"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={tValue == 3 ? "tw:block" : "tw:hidden"}
                id="naritaTerminalThree-tab-pane-md"
                role="tabpanel"
                aria-labelledby="naritaTerminalThree-tab-md"
                tabIndex="0"
              >
                <div className="tw:flex tw:flex-wrap tw:mx-[calc(var(--gx)/-2)] tw:[--gx:0rem]">
                  <div className="tw:mb-4">
                    <div className="tw:flex tw:flex-wrap tw:mx-[calc(var(--gx)/-2)] tw:[--gx:0rem]">
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none">
                        <img
                          // src={naritat2}
                          src={
                            lang === "EN"
                              ? cmspage?.page_content_en.image5
                              : cmspage?.page_content_jp.image5
                          }
                          className="img-cover tw:rounded-l-[0.375rem]"
                          alt="Narita Airport Terminal 3 map"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- section 4 terms--> */}
      {/* <!-- section 4 heading --> */}
      <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-0 tw:mb-12 tw:items-center tw:lg:pt-12">
        <div className="tw:flex-1 tw:basis-0 tw:grow tw:px-0">
          <hr />
        </div>
        <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:text-center">
          <h3
            dangerouslySetInnerHTML={{
              __html:
                lang === "EN"
                  ? cmspage?.page_content_en.content12
                  : cmspage?.page_content_jp.content12,
            }}
          >
            {/* {t("Pricing.Heading.Three")} */}
          </h3>
        </div>
        <div className="tw:flex-1 tw:basis-0 tw:grow tw:px-0">
          <hr />
        </div>
      </div>
      {/* <!-- section 4 heading, end --> */}
      <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:px-[calc(var(--gx)/2)] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:md:w-[91.6667%] tw:md:flex-none tw:lg:w-3/4 tw:lg:flex-none tw:my-12">
        <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-0">
          <div
            className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:lg:w-[83.3333%] tw:lg:flex-none tw:lg:ml-[8.3333%]"
            dangerouslySetInnerHTML={{
              __html:
                lang === "EN"
                  ? cmspage?.page_content_en.content13
                  : cmspage?.page_content_jp.content13,
            }}
          >
            {/* <p>{t("Pricing.Heading.Three.Subheading.Two.Paragraph.One")}</p>
            <ul>
              <li className="tw:my-1">
                {t("Pricing.Heading.Three.Subheading.Two.Paragraph.Two")}{" "}
              </li>
              <li className="tw:my-1">
                {t("Pricing.Heading.Three.Subheading.Two.Paragraph.Three")}{" "}
              </li>
              <li className="tw:my-1">
                {t("Pricing.Heading.Three.Subheading.Two.Paragraph.Four")}
              </li>
              <li className="tw:my-1">
                {t("Pricing.Heading.Three.Subheading.Two.Paragraph.Five")}
              </li>
              <li className="tw:my-1">
                {t("Pricing.Heading.Three.Subheading.Two.Paragraph.Six")}
              </li>
              <li className="tw:my-1">
                {t("Pricing.Heading.Three.Subheading.Two.Paragraph.Seven")}{" "}
                &nbsp;
                <span>
                  <Link className={``} to="./pricing">
                    {t(
                      "Pricing.Heading.Three.Subheading.Two.Paragraph.Seven.Link"
                    )}
                  </Link>
                </span>
                &nbsp;{" "}
                {t(
                  "Pricing.Heading.Three.Subheading.Two.Paragraph.Seven.Part.Two"
                )}
              </li>
            </ul> */}
          </div>
        </div>
      </div>
      {/* <!-- section 4 end--> --> */}
      {/* <!-- banner --> */}
      <div
        className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:px-[calc(var(--gx)/2)] cta-banner-narita"
        style={{
          background:
            "url('" +
            (lang === "EN"
              ? cmspage?.page_content_en.image4
              : cmspage?.page_content_jp.image4) +
            "')",
        }}
      >
        <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-0">
          <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:py-6 tw:my-6 tw:md:flex tw:flex-col tw:justify-center tw:items-center">
            <div
              className="tw:bg-transparent tw:border-0 tw:py-2 tw:px-4 tw:mb-0 tw:[font-family:var(--font-sans-primary)] tw:font-bold tw:tracking-[3px] tw:text-[0.5rem]! tw:uppercase tw:text-center tw:mt-12 tw:md:mt-0"
              dangerouslySetInnerHTML={{
                __html:
                  lang === "EN"
                    ? cmspage?.page_content_en.content14
                    : cmspage?.page_content_jp.content14,
              }}
            >
              {/* {t("Airport.Transfer")} */}
            </div>
            <div className="tw:mb-2 tw:text-center tw:mb-6">
              <h2
                className="cta-heading"
                dangerouslySetInnerHTML={{
                  __html:
                    lang === "EN"
                      ? cmspage?.page_content_en.content15
                      : cmspage?.page_content_jp.content15,
                }}
              >
                {/* {t("Narita.Airport")} */}
              </h2>
            </div>

            <div className="tw:grid tw:gap-2 tw:md:block tw:mt-auto">
              <button
                onClick={() => history.push("./book")}
                type="button"
                className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none tw:bg-transparent tw:border-[#dbbe78] tw:text-white tw:hover:bg-[#dbbe78] tw:hover:border-[#dbbe78] tw:hover:text-[#282828] tw:text-[1.25rem] tw:rounded-[0.5rem] tw:py-2 tw:px-4 tw:px-1 tw:md:mr-2"
              >
                <div className="tw:flex tw:items-center tw:justify-center tw:px-2">
                  {/* {t("Book.Your.Journey")} */}
                  <span
                    dangerouslySetInnerHTML={{
                      __html:
                        lang === "EN"
                          ? cmspage?.page_content_en.content16
                          : cmspage?.page_content_jp.content16,
                    }}
                  ></span>
                  <i className="tw:pl-2">
                    <ArrowRightIcon color="#4A4A4A" size={24} />
                  </i>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </FrontLayout>
  );
};

export default NaritaAirportTransfer;
